import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { ELEMENT_ICON } from './defaults';
import { deserializeIcon } from './deserializeIcon';
import { renderIconElement } from './renderIconElement';
import { IconPluginsOptions } from './types';

export const IconPlugin = (options?: IconPluginsOptions): SlatePlugin => {
  return {
    renderElement: renderIconElement(options),
    inlineTypes: [ELEMENT_ICON],
    voidTypes: [ELEMENT_ICON],
    deserialize: deserializeIcon(),
  };
};

export const IconReadOnlyPlugin = (options?: IconPluginsOptions): SlatePlugin => {
  return {
    renderElement: renderIconElement(options),
    inlineTypes: [ELEMENT_ICON],
  };
};
